import type { TextInputContainerProps } from './TextInputContainer.tsx';
import { Children } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { TextInputContainer } from './TextInputContainer.tsx';
import { TextInputGroupContext } from './TextInputGroupContext.ts';

export interface TextInputGroupProps extends Pick<
  TextInputContainerProps,
  'cornerText' | 'disabled' | 'error' | 'helpText' | 'label' | 'rounded' | 'showErrorIcon'
> {
  children: React.ReactNode;
}

export function TextInputGroup({ children, ...rest }: TextInputGroupProps) {
  const childElements = flattenChildren(children);

  return (
    <TextInputContainer {...rest}>
      <div className="flex items-stretch">
        {/* oxlint-disable-next-line react/no-react-children */}
        {Children.map(childElements, (input, index) => (
          <TextInputGroupContext
            value={{
              index,
              isFirst: index === 0,
              isLast: index === childElements.length - 1
            }}
          >
            {input}
          </TextInputGroupContext>
        ))}
      </div>
    </TextInputContainer>
  );
}
